import { CheckCircle2 } from "lucide-react";
import { CLIENTS, IMAGES } from "@/lib/constants";
import { useInView } from "@/hooks/useInView";

export const WhoWeServe = () => {
  const { ref, inView } = useInView();
  return (
    <section
      id="who-we-serve"
      data-testid="who-we-serve-section"
      className="relative bg-[#0A1128] py-24 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-15">
        <img
          src={IMAGES.skyline}
          alt=""
          className="w-full h-full object-cover"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(10,17,40,0.92) 0%, rgba(10,17,40,0.96) 100%)",
          }}
        />
      </div>
      <div className="ra-grain absolute inset-0" />

      <div ref={ref} className="relative max-w-[1320px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-10 mb-14 md:mb-20 items-end">
          <div className="lg:col-span-7">
            <div className="ra-eyebrow on-dark mb-6">
              <span className="ra-hairline" />
              <span>Clientele</span>
            </div>
            <h2 className="font-heading text-white text-3xl md:text-4xl lg:text-[52px] font-medium leading-[1.08] tracking-tight">
              Who We Work With
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="font-body text-white/65 text-base md:text-[17px] leading-relaxed">
              Trusted by capital allocators and operators across commercial,
              residential, and institutional real estate.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/8">
          {CLIENTS.map((c, i) => (
            <div
              key={c}
              data-testid={`client-type-${i}`}
              className={`bg-[#0A1128] p-7 md:p-8 group cursor-default fade-up ${
                inView ? "in-view" : ""
              } transition-colors hover:bg-[#1C2541]`}
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              <div className="flex items-start gap-3">
                <CheckCircle2
                  size={18}
                  strokeWidth={1.8}
                  className="text-[#00A859] mt-0.5 shrink-0"
                />
                <div>
                  <div className="font-body text-white/45 text-[10px] tracking-[0.3em] uppercase mb-2">
                    0{i + 1}
                  </div>
                  <div className="font-heading text-white text-[17px] md:text-lg font-medium leading-snug">
                    {c}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeServe;
